import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { StepperComponent } from './stepper.component'
import { TooltipModule } from 'primeng/tooltip'
import { RouterModule } from '@angular/router'

@NgModule({
  declarations: [StepperComponent],
  imports: [CommonModule, TooltipModule, FormsModule, RouterModule],
  exports: [StepperComponent],
})
export class StepperModule {}
